<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="6" lg="7" md="9" cols="12">
            <v-stepper-vertical color="secondary" eager flat :items="steps" v-model="stepper">
                <template #item.1>
                    <v-form ref="step1Form">
                        <switch-input v-model="form.status" label="وضعیت"></switch-input>
                        <v-autocomplete
                            :rules="$validation('required')"
                            multiple
                            no-data-text="موردی پیدا نشد!"
                            v-if="$auth.user.full_admin"
                            :items="branchList"
                            item-title="name"
                            item-value="id"
                            label="* شعبه"
                            v-model="form.branches"
                        >
                            <template #prepend-item>
                                <toggle-select-all @clicked="$text.toggleSelectAll('form.branches' , 'branchList', $data)" :items='form.branches' :all='branchList'></toggle-select-all>
                            </template>
                        </v-autocomplete>
                    </v-form>
                </template>
                <template #item.2>
                    <v-form ref="step2Form">
                        <v-select
                            :rules="$validation('required')"
                            :items="announcementTypes"
                            label="* میزان اهمیت"
                            item-title="title"
                            no-data-text="موردی پیدا نشد!"
                            item-value="id"
                            v-model="form.announcement_type_id"
                        ></v-select>
                        <v-row wrap justify="start" align="center">
                            <v-col sm="5" cols="12">
                                <datetime-input
                                    :rules="$validation('required')"
                                    :jumpMinute="5"
                                    :roundMinute="true"
                                    label="* تاریخ شروع"
                                    type="datetime"
                                    clearable
                                    v-model="form.start_date"
                                    @update:modelValue="(value) => form.end_date = value > form.end_date ? null : form.end_date"
                                ></datetime-input>
                            </v-col>
                            <v-col sm="2" cols="auto" class="mb-5 text-center mx-auto"><span class="px-3 py-1 text-meta text-white bg-primary rounded">تا</span></v-col>
                            <v-col sm="5" cols="12">
                                <datetime-input
                                    :rules="$validation('required')"
                                    :jumpMinute="5"
                                    :roundMinute="true"
                                    :disabled="!form.start_date"
                                    :min="form.start_date"
                                    label="* تاریخ پایان"
                                    type="datetime"
                                    clearable
                                    v-model="form.end_date"
                                ></datetime-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
                <template #item.3>
                    <v-form ref="step3Form">
                        <v-text-field
                            :rules="$validation('required')"
                            label="* عنوان"
                            v-model="form.name"
                        ></v-text-field>
                        <ckeditor
                            class="mb-4"
                            v-model="form.content"
                        />
                    </v-form>
                </template>
                <template #title="{title}">
                    <span class="text-meta cursor-pointer font-weight-regular">{{title}}</span>
                </template>
                <template #actions="{step}">
                    <div class="mt-3">
                        <v-btn @click="changeStep(step + 1)" color="success" :loading="loading">{{ step == steps.length ? 'ثبت اطلاعات' : 'ثبت و ادامه'}}</v-btn>
                        <v-btn v-if="step > 1" @click="changeStep(step - 1)" color="error" class="ms-3" variant="text" :disabled="loading">بازگشت</v-btn>
                    </div>
                </template>
            </v-stepper-vertical>
        </v-col>
    </div>
</template>
<script>
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
export default {
    title: "ایجاد",
    components: {
        VStepperVertical,
    },
    validate(context) {
        return context.auth.user.full_admin || context.auth.user.branch_admin;
    },
    data() {
        return {
            loading: false,
            steps: [
                { title: 'مخاطب اطلاعیه', value: 1 },
                { title: 'میزان اهمیت و دوره نمایش', value: 2 },
                { title: 'عنوان و متن اطلاعیه', value:  3}
            ],
            stepper: 1,
            form: {
                status: true,
                branches: [],
                start_date: null,
                end_date: null,
                announcement_type_id: null,
                name: null,
                content: '',
                employee: 0,
            },
            branchList: [],
            announcementTypes: [],
        };
    },
    methods: {
        async changeStep(step) {
            for (let i = 1; i < step; i++)
                if (this.$refs[`step${i}Form`] && !(await this.$refs[`step${i}Form`]?.validate())?.valid)
                    return this.stepper = i;
            if (step <= this.steps.length)
                this.stepper = step;
            else
                this.submit();
        },
        submit() {
            if (!this.form.content.replace(/<[^>]*>?/gm, ''))
                return this.$toast.error('تكميل متن اطلاعیه الزامي است');
            this.loading = true;
            this.$announcementStore(this.form).then((res) => {
                if (res && res.status == "CREATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemDefaults(true);
                    this.$router.push({path: '/customerAnnouncement'});
                }
            }).finally(()=>{this.loading = false;});
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$loading.start();
            if (this.$auth.user.full_admin)
                this.branchList = this.$system.branches;
            this.announcementTypes = this.$system.announcementTypes;
            this.$loading.finish();
        });
    },
};
</script>
